import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CreateOrganization from './Create/CreateOrganization';
import OrganizationSearch from './Search/OrganizationSearch';
import OrganizationDetails from './Details/OrganizationDetails';

const useStyles = makeStyles((theme) => ({
  active: {
    backgroundColor: 'rgba(16, 192, 198, 0.08)'
  }
}));

const Organizations = (props) => {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const previousRoute = props.match.url;
  const pathName = props.location.pathname;
  const classes = useStyles();

  const handleChangePage = (page) => {
    history.push(`${previousRoute}/${page}`);
  };

  const isPageActive = (page) => pathName.search(page) !== -1;

  return (
    <>
      <Grid container justifyContent="center" alignItems="baseline">
        <Grid item>
          <Button color="primary" className={isPageActive('search') ? classes.active : ''} onClick={() => handleChangePage('search')} >
            {translate('search organizations')}
          </Button>
        </Grid>
        <Grid item>
          <Button color="primary" className={isPageActive('create') ? classes.active : ''} onClick={() => handleChangePage('create')}>
            {translate('create organization')}
          </Button>
        </Grid>
      </Grid>
      <Grid>
        <Switch>
          <Route path={previousRoute + '/search'} component={OrganizationSearch} />
          <Route path={previousRoute + '/details/:OrgId'} component={OrganizationDetails}/>
          <Route path={previousRoute + '/create'} component={CreateOrganization} />
          <Redirect to={previousRoute + '/search'} />
        </Switch>
      </Grid>
    </>
  );
};

export default Organizations;
